module.exports = __webpack_public_path__ + "static/media/ProjectTwo.b9bce4a0.mp4";